<div class="date-picker-container" [class.readonly]="readonly" [class.without-hours] = "!showRangeOptions && !withHours">
  @if (showClearButton && formattedDate?.trim()) {
    <div class="delete-btn" [class.no-time-picker]="noTimePicker" (click)="delete()">
      <img alt="Close" src="/assets/icons/close-icon.svg">
    </div>
  }
  <label>
    <input #inputField
      readonly
      maxlength="500"
      [replaceKeys]="true"
      [fiTranslation]="formattedDate"
      (blur)="inputField.readOnly = true"
      (click)="onInputClick($event)"
      (keydown.enter)="toggleCalendar(); $event.stopPropagation(); $event.preventDefault();"
      (input)="onChange($event)"
      (cut)="$event.preventDefault()"
      (paste)="$event.preventDefault()"
      class="date-input-field"
      [class.show-error-border]="false"
      [class.readonly]="readonly"
      [placeholder]="rangeButtons ? '' : (withHours ? 'tt.mm.jjjj  --:--' : placeholderWithoutHours)">
    <span class="calendar-icon" [style.pointer-events]="showRangeOptions ? 'none' : ''">
      <img src="/assets/icons/calendar.svg" alt="calendar" (click)="toggleCalendar(); $event.stopPropagation(); $event.preventDefault();" #datePicker [isTitle] = "true" fiTranslation="ALT_TEXT_REQUEST_LIST_CALENDAR" matTooltip="{{isMobile ? undefined: datePicker.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
    </span>
  </label>
</div>

<ng-template #calendar>

  <div class="calendar-container"
    [class.absolute-positioning]="absolutePositioning"
    [class.transparent-overlay]="transparentOverlay"
    [class.active]="active"
    (click)="toggleCalendar($event)"
    (keydown.esc)="toggleCalendar(); $event.stopPropagation()"
    [ngStyle]="calendarStyles">
    <div class="top-border"></div>
    <div class="bottom-border"></div>
    <div class="calendar" (click)="$event.stopPropagation()">
      <div class="day-picker">
        <div class="header">
          <div><span [fiTranslation]="'_MONTH_' + selectedMonthIndex + '_SHORT'"></span> {{selectedYear}}</div>
          <div class="buttons">
            <button class="up" (click)="getDaysForMonth('previous')">
              <img alt="Arrow up" src="/assets/icons/arrow-down-dark.svg">
              <span class="u-hidden-visually" fiTranslation="ALT_TEXT_CALENDAR_PREVIOUS_MONTH"></span>
            </button>
            <button (click)="getDaysForMonth('next')">
              <img alt="Arrow down" src="/assets/icons/arrow-down-dark.svg">
              <span class="u-hidden-visually" fiTranslation="ALT_TEXT_CALENDAR_NEXT_MONTH"></span>
            </button>
          </div>
        </div>
        <div class="week-days">
          @for (weekDayIndex of [0,1,2,3,4,5,6] ; track weekDayIndex) {
            <div class="date-time-cell" [class.range-cell] = "selectMode === 'range' && !showRangeOptions">
              <span [fiTranslation]="'_WEEK_DAY_' + weekDayIndex + '_SHORT'"></span>
            </div>
          }
        </div>

        <div class="days" [class.hide] ="selectMode !== 'single'" #daysContainer>
          @for (padding of weekdayPaddings; track padding) {
            <div class="date-time-cell"></div>
          }
          @for (day of days; track day; let i = $index) {
            <button
              (click)="onSelectDate(i)"
              (keydown)="onKeydown($event, true, i)"
              [class.selected]="isDate1Touched && (i === selectedDay1Index || i === selectedDay2Index)"
              [class.in-range]="isDate1Touched && selectMode === 'range' && i >= selectedDay1Index && i <= selectedDay2Index"
              class="date-time-cell">
              {{day}}
            </button>
          }
        </div>

        <div class="days" [class.hide] ="selectMode !== 'range'" #daysContainer>
          <div class="range">
            @for (padding of weekdayPaddings; track padding) {
              <div class="date-time-cell" [class.range-cell]="!showRangeOptions"></div>
            }
            @for (day of firstColumn; track day; let i = $index) {
              <button
                (click)="onSelectDate(i)"
                (keydown)="onKeydown($event, true, i)"
                [class.today]="i === currentDayIndex"
                [class.selected]="isDate1Touched && (i === selectedDay1Index || i === selectedDay2Index)"
                [class.in-range]="isDate1Touched && selectMode === 'range' && i >= selectedDay1Index && i <= selectedDay2Index"
                [class.range-cell]="!showRangeOptions"
                class="date-time-cell">
                {{day}}
              </button>
            }
          </div>

          <div class="range">
            @for (day of secondColumn; track day; let i = $index) {
              <button
                (click)="onSelectDate(this.toFirstColumnLength + i)"
                (keydown)="onKeydown($event, true, this.toFirstColumnLength + i)"
                [class.today]="(this.toFirstColumnLength + i) === currentDayIndex"
                [class.selected]="isDate1Touched && ((this.toFirstColumnLength + i) === selectedDay1Index || (this.toFirstColumnLength + i) === selectedDay2Index)"
                [class.in-range]="isDate1Touched && selectMode === 'range' && (this.toFirstColumnLength + i) >= selectedDay1Index && (this.toFirstColumnLength + i) <= selectedDay2Index"
                [class.range-cell]="!showRangeOptions"
                class="date-time-cell">
                {{day}}
              </button>
            }
          </div>

          <div class="range">
            @for (day of thirdColumn; track day; let i = $index) {
              <button
                (click)="onSelectDate(this.toSecondColumnLength + i)"
                (keydown)="onKeydown($event, true, this.toSecondColumnLength + i)"
                [class.today]="(this.toSecondColumnLength + i) === currentDayIndex"
                [class.selected]="isDate1Touched && ((this.toSecondColumnLength + i) === selectedDay1Index || (this.toSecondColumnLength + i) === selectedDay2Index)"
                [class.in-range]="isDate1Touched && selectMode === 'range' && (this.toSecondColumnLength + i) >= selectedDay1Index && (this.toSecondColumnLength + i) <= selectedDay2Index"
                [class.range-cell]="!showRangeOptions"
                class="date-time-cell">
                {{day}}
              </button>
            }
          </div>

          <div class="range">
            @for (day of fourthColumn; track day; let i = $index) {
              <button
                (click)="onSelectDate(this.toThirdColumnLength + i)"
                (keydown)="onKeydown($event, true, this.toThirdColumnLength + i)"
                [class.today]="(this.toThirdColumnLength + i) === currentDayIndex"
                [class.selected]="isDate1Touched && ((this.toThirdColumnLength + i) === selectedDay1Index || (this.toThirdColumnLength + i) === selectedDay2Index)"
                [class.in-range]="isDate1Touched && selectMode === 'range' && (this.toThirdColumnLength + i) >= selectedDay1Index && (this.toThirdColumnLength + i) <= selectedDay2Index"
                [class.range-cell]="!showRangeOptions"
                class="date-time-cell">
                {{day}}
              </button>
            }
          </div>

          <div class="range">
            @for (day of fifthColumn; track day; let i = $index) {
              <button
                (click)="onSelectDate(this.toFourthColumnLength + i)"
                (keydown)="onKeydown($event, true, this.toFourthColumnLength + i)"
                [class.today]="(this.toFourthColumnLength + i) === currentDayIndex"
                [class.selected]="isDate1Touched && ((this.toFourthColumnLength + i) === selectedDay1Index || (this.toFourthColumnLength + i) === selectedDay2Index)"
                [class.in-range]="isDate1Touched && selectMode === 'range' && (this.toFourthColumnLength + i) >= selectedDay1Index && (this.toFourthColumnLength + i) <= selectedDay2Index"
                [class.range-cell]="!showRangeOptions"
                class="date-time-cell">
                {{day}}
              </button>
            }
            @for (padding of emptyFifthColumn; track padding) {
              <div [class.range-cell]="!showRangeOptions" class="date-time-cell"></div>
            }
          </div>

          <div class="range">
            @for (day of sixthColumn; track day; let i = $index) {
              <button
                (click)="onSelectDate(this.toFifthColumnLength + i)"
                (keydown)="onKeydown($event, true, this.toFifthColumnLength + i)"
                [class.today]="(this.toFifthColumnLength + i) === currentDayIndex"
                [class.selected]="isDate1Touched && ((this.toFifthColumnLength + i) === selectedDay1Index || (this.toFifthColumnLength + i) === selectedDay2Index)"
                [class.in-range]="isDate1Touched && selectMode === 'range' && (this.toFifthColumnLength + i) >= selectedDay1Index && (this.toFifthColumnLength + i) <= selectedDay2Index"
                [class.range-cell]="!showRangeOptions"
                class="date-time-cell">
                {{day}}
              </button>
            }
            @for (padding of emptySixthColumn; track padding) {
              <div class="date-time-cell" [class.range-cell]="!showRangeOptions"></div>
            }
          </div>

        </div>
      </div>
      @if ((selectMode !== 'range' && !noTimePicker) || showRangeOptions) {
        <div class="time-picker" [class.wide]="showRangeOptions">
          @if (selectMode !== 'range') {
            <div class="header">
              <div fiTranslation="ACTION_GENERAL_HEADLINE_TIME"></div>
            </div>
            <div class="times" #times>
              <div class="scroll">
                @for (hour of hours; track hour; let i = $index) {
                  <button
                    (keydown)="onKeydown($event, false, i)"
                    (click)="onSelectTime(i, this.selectedMinuteIndex)"
                    [class.selected]="i === selectedHourIndex"
                    class="date-time-cell">
                    {{hour}}
                  </button>
                }
              </div>
              <div class="scroll">
                @for (minute of minutes; track minute; let i = $index) {
                  <button
                    (keydown)="onKeydown($event, false, i)"
                    (click)="onSelectTime(this.selectedHourIndex, i)"
                    [class.selected]="i === selectedMinuteIndex"
                    class="date-time-cell">
                    {{minute}}
                  </button>
                }
              </div>
            </div>
          }
          @if (showRangeOptions) {
            @for (rangeButton of rangeButtons; track rangeButton; let i = $index) {
              <div class="range-option"
                (click)="setRange(i)">
                <span class="checkbox" [class.selected]="i === rangeButtonIndex"></span><span class="label" [fiTranslation]="'SEARCH_DATE_'+ rangeButton.key"></span>
              </div>
            }
          }
        </div>
      }
    </div>
    @if (appointmentExists) {
      <div [class.show-warning]="appointmentExists">
        <span fiTranslation="ACTION_APPOINTMENT_OVERLAP"></span>
      </div>
    }

    @if (this.selectMode === 'range' && !showRangeOptions) {
      <div>
        <div class="line"></div>
        <div class="toggle-button" (click)="toggleRecurring(); $event.stopPropagation()">
          @if (!showRecurring) {
            +
          } @else {
            -
          }
          <span fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_H1"></span>
        </div>
        @if (showRecurring) {
          <div class="absence-container" (click)="$event.stopPropagation()">
            <div class="title" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_H2"></div>
            <div class="toggle-btn-cont">
              <fi-checkbox (checkedChange)="updateInputText()" class="toggle-btn" [(ngModel)]="recurringDays.monday.checked">
                <span class="toggle-text" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_MONDAY"></span>
              </fi-checkbox>
            </div>
            <div class="toggle-btn-cont">
              <fi-checkbox (checkedChange)="updateInputText()" class="toggle-btn" [(ngModel)]="recurringDays.tuesday.checked">
                <span class="toggle-text" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_TUESDAY"></span>
              </fi-checkbox>
            </div>
            <div class="toggle-btn-cont">
              <fi-checkbox (checkedChange)="updateInputText()" class="toggle-btn" [(ngModel)]="recurringDays.wednesday.checked">
                <span class="toggle-text" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_WEDNESDAY"></span>
              </fi-checkbox>
            </div>
            <div class="toggle-btn-cont">
              <fi-checkbox (checkedChange)="updateInputText()" class="toggle-btn" [(ngModel)]="recurringDays.thursday.checked">
                <span class="toggle-text" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_THURSDAY"></span>
              </fi-checkbox>
            </div>
            <div class="toggle-btn-cont">
              <fi-checkbox (checkedChange)="updateInputText() "class="toggle-btn" [(ngModel)]="recurringDays.friday.checked">
                <span class="toggle-text" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_FRIDAY"></span>
              </fi-checkbox>
            </div>
            <div class="toggle-btn-cont">
              <fi-checkbox (checkedChange)="updateInputText()" class="toggle-btn" [(ngModel)]="recurringDays.saturday.checked">
                <span class="toggle-text" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_SATURDAY"></span>
              </fi-checkbox>
            </div>
            <div class="toggle-btn-cont">
              <fi-checkbox (checkedChange)="updateInputText()" class="toggle-btn" [(ngModel)]="recurringDays.sunday.checked">
                <span class="toggle-text" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_SUNDAY"></span>
              </fi-checkbox>
            </div>
            <div class="title time" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING"></div>
            <div class="time-cont">
              <div fiCustomSelect
                (value)="setRecurringFrom($event * 1)"
                [data]="timesFrom"
                [displaySelectionValue]="recurringTimeFromId"
                [dataValueKey]="'Id'"
                [dataNameKey]="'Time'"
                [class.invalid]="false"
                class="select-origin select from input-field">
                <span class="selected-value placeholder"></span>
                <input maxlength="500" class="search">
                <img src="assets/icons/arrow-down-dark.svg" alt="icon" class="arrow">
                <div class="options-cont">
                  <ul class="options">
                    <li class="option" data-value="0">test 1</li>
                    <li class="option" data-value="1">test 2</li>
                  </ul>
                </div>
              </div>
              <div fiCustomSelect
                (value)="setRecurringTo($event * 1)"
                [displaySelectionValue]="recurringTimeToId"
                [data]="timesTo"
                [dataValueKey]="'Id'"
                [dataNameKey]="'Time'"
                [class.invalid]="false"
                class="select-origin select input-field">
                <span class="selected-value placeholder"></span>
                <input maxlength="500" class="search">
                <img src="assets/icons/arrow-down-dark.svg" alt="icon" class="arrow">
                <div class="options-cont">
                  <ul class="options">
                    <li class="option" data-value="0">test 1</li>
                    <li class="option" data-value="1">test 2</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }

  </div>

</ng-template>

